var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('pp-app',{class:{'is-mobile': _vm.isMobile},style:(_vm.cssVars),attrs:{"data-iframe-width":""}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }